import { useState, useEffect, useCallback, useMemo, memo } from "react";
import { Header } from "../../components/header";
import { getQueryVariable } from "../../services/util";
import { documentStatus } from "../../constants/statusConstants";
import { DocumentList } from "./components/document/document-list";
import { DocumentTagsList } from "./components/document/doucment-tags-list";
import { useSearchParams } from "../../hook/use-search-params";
import { DocumentStatusList } from "./components/document/document-status-list";
import { DocumentNeedProcessList } from "./components/document/document-need-process-list";
import { DocumentTemplate } from "./components/document/document-template";
import { DocumentExpiredList } from "./components/document/document-expired-list";
import { PublishDocumentList } from "./components/document/publish-document-list";
import { useUser } from "../../hook";
import DocumentTabs from "./components/document-tabs";

import styles from "./document-page.module.scss";
import { getEnv } from "../../AppConfigs";

const publishListId = getEnv("REACT_APP_PUBLIC_FOLDER_AND_FILE_SP_LIST_ID");

export const DocumentPage = memo(() => {
  const [selectedMenu, setSelectedMenu] = useState<any>("Danh sách tài liệu");
  const [filterExpired] = useState(getQueryVariable("filter-expired"));
  const { searchParams, replaceSearchParams } = useSearchParams();
  const statusQuery = searchParams.get("status") || "";
  const { userAdmin } = useUser();
  const isExpired = !!searchParams.get("filter-expired");

  const setSelectedMenuTextBaseOnStatus = useCallback(
    (status: string) => {
      switch (status) {
        case documentStatus.compose.value:
          setSelectedMenu("Tài liệu đang soạn thảo");
          break;
        case documentStatus.approval.value:
          setSelectedMenu("Tài liệu cần duyệt");
          break;
        case documentStatus.publish.value:
          filterExpired === "true" ? setSelectedMenu("Tài liệu lỗi thời ") : setSelectedMenu("Tài liệu ban hành");
          break;
        case documentStatus.needProcess.value:
          setSelectedMenu("Tài liệu cần xử lý");
          break;
        case documentStatus.template.value:
          setSelectedMenu("Danh sách templates");
          break;
        default:
          setSelectedMenu("Danh sách tài liệu");
          break;
      }
    },
    [filterExpired],
  );

  const renderDocumentList = useMemo(() => {
    if (statusQuery === "tags") return <DocumentTagsList />;
    if (statusQuery === "compose" || statusQuery === "approval") return <DocumentStatusList />;
    if (statusQuery === "needprocess") return <DocumentNeedProcessList />;
    if (statusQuery === "template") return <DocumentTemplate />;
    if (statusQuery === "publish" && isExpired) return <DocumentExpiredList />;
    if (statusQuery === "publish")
      return (
        <PublishDocumentList
          statusQuery={statusQuery}
          filterExpired={filterExpired}
          listId={publishListId}
          menuTitle={selectedMenu}
          isShowAction={true}
        />
      );
    return (
      <DocumentList
        statusQuery={statusQuery}
        filterExpired={filterExpired}
        menuTitle={selectedMenu}
        isShowAction={true}
      />
    );
  }, [filterExpired, isExpired, selectedMenu, statusQuery]);

  useEffect(() => {
    if (userAdmin) return;
    if (!userAdmin?.id) {
      searchParams.set("status", "publish");
      replaceSearchParams(searchParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userAdmin, searchParams]);

  return (
    <div className={styles.container}>
      <Header />
      <main className={styles.main}>
        <div className={styles.tabs}>
          <DocumentTabs setSelectedMenuTextBaseOnStatus={setSelectedMenuTextBaseOnStatus} />
        </div>
        <div className={styles.content}>{renderDocumentList}</div>
      </main>
    </div>
  );
});
